const routes = [
  {
    path: 'hello-threejs',
    name: 'helloThreejs',
    component: () => import(/* webpackChunkName: "hello-threejs" */ '@/modules/hello-threejs/index.vue')
  },
];

export default routes;